import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";

@Component({
  selector: 'app-verificationpopup',
  templateUrl: './verificationpopup.component.html',
  styleUrls: ['./verificationpopup.component.scss']
})
export class VerificationpopupComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;
  userForm: {};
  userProfile: {};
  mainOtp = '';
  otp = {};
  errorOtp = false;
  input1 = new EventEmitter<boolean>();
  input2 = new EventEmitter<boolean>();
  input3 = new EventEmitter<boolean>();
  input4 = new EventEmitter<boolean>();
  @ViewChild("verifyModalContent") private verifyModalContent: ElementRef;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.getUserprofiledata();
    this.errorOtp = false;
  }

  closeModal() {
    this.getUserprofiledata();
    this.modalRef.close();
  }

  open() {
    this.modalRef = this.modalService.open(this.verifyModalContent);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getUserprofiledata() {
    const userProfile = {
      "user_id": this.dataService.userDetails["user_id"]
    }
    this.apiService.getUserProfile(userProfile, (response) => {
      this.userForm = response;
    });
  }

  _keyPress(event: any, index) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    const code = event.keyCode || event.which;
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }

    this.setFocus(index);

  }

  setFocus(index){
    if(index === 1){
      this.input2.emit(true);
    }
    if(index === 2){
      this.input3.emit(true);
    }
    if(index === 3){
      this.input4.emit(true);
    }

  }

  otpsubmit() {
    this.mainOtp = this.otp['userOtp1'] + this.otp['userOtp2'] + this.otp['userOtp3'] + this.otp['userOtp4'];
    if (this.dataService.otpSendPhone == this.mainOtp) {
      this.dataService.userDetails['profile'].mobileVerified = true;
      this.userProfile = {
        "user_id": this.dataService.userDetails["user_id"],
        "mobileVerified": true,
      }
      this.dataService.setProfile();
      this.updateuser();
      this.dataService.getUserprofiledata();
      this.closeModal();
      this.errorOtp = false;
      this.otp = {};
    }else if (this.dataService.otpSendEmail == this.mainOtp) {
      this.dataService.userDetails['profile'].emailVerified = true;
      this.userProfile = {
        "user_id": this.dataService.userDetails["user_id"],
        "emailVerified": true,
      }
      this.dataService.setProfile();
      this.updateuser();
      this.dataService.getUserprofiledata();
      this.closeModal();
      this.errorOtp = false;
      this.otp = {};
    }
    else {
      this.dataService.userDetails['profile'].emailVerified = false;
      this.dataService.userDetails['profile'].mobileVerified = false;
      this.errorOtp = true;
    }
  }

  updateuser() {
    this.apiService.updateProfile(this.userProfile, (response) => {
      if (response['response'] == 'ok') {
        this.frontEndService.addToast("Success", response['message'], "success");
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/verificationpopup/verificationpopup.component.ts